export enum ChatMsgType
{
  fromDriver,
  fromOperator,
  withOptions,
  withResponse
}
